__turbopack_context__.v({
  "accent": "theme-module__Pjag7W__accent",
  "backdrop": "theme-module__Pjag7W__backdrop",
  "berry-moderate": "theme-module__Pjag7W__berry-moderate",
  "berry-standard": "theme-module__Pjag7W__berry-standard",
  "berry-strong": "theme-module__Pjag7W__berry-strong",
  "berry-subtle": "theme-module__Pjag7W__berry-subtle",
  "dark": "theme-module__Pjag7W__dark",
  "dark-scheme": "theme-module__Pjag7W__dark-scheme",
  "info-strong": "theme-module__Pjag7W__info-strong",
  "info-subtle": "theme-module__Pjag7W__info-subtle",
  "inverse": "theme-module__Pjag7W__inverse",
  "light-scheme": "theme-module__Pjag7W__light-scheme",
  "moss-moderate": "theme-module__Pjag7W__moss-moderate",
  "moss-standard": "theme-module__Pjag7W__moss-standard",
  "moss-strong": "theme-module__Pjag7W__moss-strong",
  "moss-subtle": "theme-module__Pjag7W__moss-subtle",
  "smoke-moderate": "theme-module__Pjag7W__smoke-moderate",
  "smoke-standard": "theme-module__Pjag7W__smoke-standard",
  "smoke-strong": "theme-module__Pjag7W__smoke-strong",
  "smoke-subtle": "theme-module__Pjag7W__smoke-subtle",
  "standard": "theme-module__Pjag7W__standard",
  "subtle": "theme-module__Pjag7W__subtle",
  "success-moderate": "theme-module__Pjag7W__success-moderate",
  "success-strong": "theme-module__Pjag7W__success-strong",
  "warning-moderate": "theme-module__Pjag7W__warning-moderate",
  "warning-strong": "theme-module__Pjag7W__warning-strong",
});
